import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/providers.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/AchievementCelebrationHost.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/AndroidAppPrompt.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/AndroidNotificationBadgeSync.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/BgAudio.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ForumShellGate.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/GlobalMediaVisibilityRuntime.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/GlobalPageBootRuntime.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/vercel/path0/components/i18n.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/InviteFriendHost.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/MetaMarketHost.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/NotRobotHost.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/PaymentMethodPopoverHost.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/QCoinDropFX.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/QCoinRuntimeBridge.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Ql7SupportRuntimeBridge.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/QuantumWalletHost.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ScreenWakeLockRuntime.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ScrollTopPulse.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/seo/RootLocaleRuntime.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ServiceGlobalBlockBridge.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/SystemSupportNotificationHost.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/TopBarRouteGate.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/UserInfoPopoverHost.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/visual-runtime/GlobalVisualActivityRuntime.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.5_@babel+core@7.29.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.5_@babel+core@7.29.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.5_@babel+core@7.29.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
